import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "userRetryPasswordModal" }

import { ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import API from "@/api";
import {
  getPasswordCodeUsingGet,
  userRetryPasswordUsingPost,
} from "@/api/userController";

const countDownInit = 60;

export default /*#__PURE__*/_defineComponent({
  __name: 'UserRetryPasswordModal',
  setup(__props, { expose: __expose }) {

const visible = ref(false);

const openModal = () => {
  visible.value = true;
};

const closeModal = () => {
  visible.value = false;
};

__expose({
  openModal,
});

const form = ref({
  userEmail: "",
  userPassword: "",
  checkPassword: "",
  code: "",
} as API.UserUpdateRequest);

const countDown = ref(countDownInit);
const loading = ref(false);
/**
 * 发送验证码
 */
const sendCode = async () => {
  if (!form.value.userEmail) {
    message.error("请输入邮箱");
    return;
  }
  const res = await getPasswordCodeUsingGet({
    email: form.value.userEmail,
  });
  if (res.data.code === 200) {
    countDown.value = countDownInit;
    loading.value = true;
    var timer = setInterval(() => {
      countDown.value--;
      if (countDown.value == 0) {
        clearInterval(timer);
        loading.value = false;
      }
    }, 1000);
    message.success("发送验证码成功，请在邮箱中查看");
  } else {
    message.error("发送验证码失败，" + res.data.message);
  }
};

/**
 * 提交
 */
const handleSubmit = async () => {
  const res = await userRetryPasswordUsingPost({
    ...form.value,
  });
  if (res.data.code === 200) {
    message.success("修改密码成功");
  } else {
    message.error("修改密码失败，" + res.data.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
      onCancel: closeModal,
      footer: false
    }, {
      title: _withCtx(() => [
        _createTextVNode(" 找回密码 ")
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: form.value,
          style: { width: '480px' },
          "label-align": "left",
          "auto-label-width": "",
          onSubmit: handleSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "userEmail",
              label: "邮箱",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: form.value.userEmail,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.userEmail) = $event)),
                  placeholder: "请输入邮箱..."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "验证码",
              "validate-trigger": "input",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: form.value.code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.code) = $event)),
                  placeholder: "请输入验证码..."
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: sendCode,
                      loading: loading.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(loading.value ? `${countDown.value}` + "后重试" : "发送验证码"), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "userPassword",
              label: "密码",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  modelValue: form.value.userPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.userPassword) = $event)),
                  placeholder: "请输入密码..."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "checkPassword",
              label: "确认密码",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  modelValue: form.value.checkPassword,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.checkPassword) = $event)),
                  placeholder: "请输入确认密码..."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit",
                  style: {"width":"120px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 提交 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})